module.exports = __webpack_public_path__ + "static/media/cesped_verano_corto.f819adb7.jpg";